// extracted by mini-css-extract-plugin
export var actionButton = "_b8-1";
export var actionButtons = "_b8-2";
export var actions = "_b8-0";
export var aiUnread = "_b8-10";
export var alignCenter = "_b8-h";
export var backWrapper = "_b8-3";
export var cellContainer = "_b8-4";
export var checkboxContainer = "_b8-5";
export var contentContainer = "_b8-6";
export var contentHeader = "_b8-8";
export var conversationsTableWrapper = "_b8-s";
export var draftReplyBadgeContainer = "_b8-m";
export var dropdownItem = "_b8-b";
export var dropdownItemsContainer = "_b8-a";
export var dropdownTitle = "_b8-c";
export var errorIcon = "_b8-7";
export var filter = "_b8-d";
export var gray = "_b8-i";
export var headerActionButtons = "_b8-e";
export var headerCheckboxContainer = "_b8-f";
export var icon = "_b8-j";
export var menuContainer = "_b8-k";
export var noMoreTicketsIcon = "_b8-12";
export var noMoreTicketsSubText = "_b8-13";
export var oneLine = "_b8-l";
export var optionsButton = "_b8-n";
export var plus = "_b8-o";
export var portalButtonsWrapper = "_b8-g";
export var red = "_b8-p";
export var scrolledTop = "_b8-9";
export var search = "_b8-q";
export var selectedConversationsCount = "_b8-r";
export var spinner = "_b8-t";
export var strong = "_b8-u";
export var summaryCell = "_b8-v";
export var tableContainer = "_b8-11";
export var tagContainer = "_b8-w";
export var threeDots = "_b8-x";
export var twoLines = "_b8-y";
export var unread = "_b8-z";